import React from 'react';
import { connect } from 'react-redux';
import ComponentWrapper from "../../common/ComponentWrapper";
import TrplsTable from '../../common/TrplsTable/TrplsTable';
import { withStyles } from '@mui/styles';
import { Paper } from '@mui/material';
import LoaderNew from '../../common/LoaderNew';
import CommonStyles from '../../common/CommonStyles';

import Filtration from './components/Filtration';

import { getJelData } from '../../reducer/jelsReducer';

import {
  nodesParams,
  boxParamsTable,
  prdcParamsTable,
  getUrlParameter,
  decodeFilterFromUrl,
  trplsParamsTableMatching,
  getTransformedTrplsArrayToObj,
  getTransformedNodesArrayToObj,
} from '../../utils';

// TODO make it env variables
const MATCHED_ORDER_PREDICATE_ID = 765;
const DRIVER_ZIP_PREDICATE_ID = 72;
const DRIVER_TRUCK_TYPE_PREDICATE_CHAIN_ID = [293, 284];
const VALID_MATCHING_PREDICATE_ID = 912;
const DRIVER_TABLE_ID = 224;
const ORDER_TABLE_ID = 229;
const DRIVER_CONCEPT_ID = 1858036;
// const ORDER_LOADED_MILES_PREDICATE_CHAIN_ID = [765, 766, 211];
// const ORDER_PICK_UP_DATE_FROM = [765, 766, 370, 367];

const styles = {
  tableContainer: {
    overflow: 'auto',
    '&::-webkit-scrollbar': {
      width: '3px',
      height: '3px',
      background: 'rgba(0,0,0, 0.2)'
    },
    '&::-webkit-scrollbar-thumb': {
      background:'rgb(179, 182, 217)',
    },
  },
  paperContainer: {
    zIndex: 0,
    margin: '25px',
    padding: '10px',
    borderRadius: '12px',
    position: 'relative',
  },
  tableLoaderOverlay: {
    top: '0',
    left: '0',
    right: '0',
    bottom: '0',
    zIndex: '1',
    display: 'flex',
    position: 'absolute',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'rgba(255,255,255,0.8)',
  },
  ...CommonStyles,
}

class MatchingPage extends ComponentWrapper {
  state = {
    data: null,
    driverOrdersPairs: null,
    initialFilters: [],
    filterFromUrl: null,
  }

  componentDidMount() {
    const { jels } = this.props;
    const filtersFromUrl = getUrlParameter('filters');

    const filterFromUrl = filtersFromUrl
      ? JSON.parse(filtersFromUrl).map(decodeFilterFromUrl)
      : [];

    const viewIds = [DRIVER_TABLE_ID, ORDER_TABLE_ID];
    if (!jels.tables.includes(DRIVER_TABLE_ID || ORDER_TABLE_ID)) this.props.getJelData(viewIds);

    this.updateData(filterFromUrl);
  };

  updateData = (filter) => {
    const { setup } = this.props;
    const driverOrdersPairs = null;
    this.setState({ driverOrdersPairs });

    let initialFilters = [
      { pids_chain: [DRIVER_ZIP_PREDICATE_ID], op: "is not null", con: "AND" },
      { pids_chain: [MATCHED_ORDER_PREDICATE_ID], op: "is not null", con: "AND" },
      { pids_chain: [MATCHED_ORDER_PREDICATE_ID, VALID_MATCHING_PREDICATE_ID], val: "true", con: "AND" }
    ];

    if (filter.length) {
      let filterFromUrl = filter;
      this.setState({ filterFromUrl })
      initialFilters.push(filterFromUrl);
    }

    const reqData = {
      nesting: 4,
      api_key: setup.id,
      filter: {
        ancestor: DRIVER_CONCEPT_ID,
        trpls: initialFilters,
      },
    };

    reqData.render = {
      trpl:{
        type:"a",
        params: trplsParamsTableMatching,
      },
      node:{
        type:"a",
        params: nodesParams,
      },
      prdc:{
        type:"a",
        params: prdcParamsTable,
      },
      box:{
        type:"a",
        params: boxParamsTable,
      }
    };

    reqData.show_pids = [MATCHED_ORDER_PREDICATE_ID, DRIVER_TRUCK_TYPE_PREDICATE_CHAIN_ID,
          64,72,1323,968,772,1325,756,"293.351","293.291","293.618","293.292","293.1481",
          "765.766","765.936","765.913","765.766.773","765.766.370.367","765.766.370.369","765.766.370.365",
          "765.766.371.367","765.766.371.369","765.766.371.365","765.766.89","765.766.88","765.766.90",
          "765.757","765.766.211","765.766.769","765.766.770","765.771","765." + VALID_MATCHING_PREDICATE_ID]

    this.postWithData({
      url: `/pnkqry3`,
      data: reqData,
      cb: (data) => {
        data.nodes = getTransformedNodesArrayToObj(data.nodes, nodesParams);
        this.setState({ data, initialFilters, driverOrdersPairs: this.generateMatchedOrdersPairs(data) });
      },
    });
  }

  generateMatchedOrdersPairs = (data) => {
    return data.query
      .map(driverPid => {
        const driverTrpls = getTransformedTrplsArrayToObj(data.trpls, driverPid, trplsParamsTableMatching);
        const matchedOrders = (driverTrpls && driverTrpls[MATCHED_ORDER_PREDICATE_ID]) || [];
        const matchedOrdersOids = matchedOrders
          .map(orderTrpl => orderTrpl.oid)
          .filter(orderId => {
            return data.trpls[orderId][VALID_MATCHING_PREDICATE_ID]
              ? getTransformedTrplsArrayToObj(data.trpls, orderId, trplsParamsTableMatching)[VALID_MATCHING_PREDICATE_ID][0].val_bool
              : false;
          });
        return [driverPid, matchedOrdersOids];
      })
      .filter(([_, matchedOrdersOids]) => matchedOrdersOids.length);
  }

  render() {
    const { jels, classes, setup } = this.props;
    const { data, driverOrdersPairs, filterFromUrl } = this.state;

    return (
      <div>
        {!driverOrdersPairs && (
          <div className={classes.tableLoaderOverlay}>
            <LoaderNew />
          </div>
        )}

        {data !== null && data.nodes ?
          <div className={`${classes.ml30} ${classes.mt30}`}>
            <Filtration
              setup={setup}
              classes={classes}
              updateData={this.updateData}
              concept={DRIVER_CONCEPT_ID}
              filterBtnText="Filter"
              filterByNodeTitle={false}
              nodes={data.nodes}
              setFilterToParentState={(filter) => {
                this.setState({ filterFromUrl: filter });
              }}
              filterFromUrl={filterFromUrl}
              //showPidsIds={jels.jelData[DRIVER_TABLE_ID].show_pids} // if it will be needed to show all predicate list
              showPidsIds={
                [DRIVER_TRUCK_TYPE_PREDICATE_CHAIN_ID, 64] //ORDER_LOADED_MILES_PREDICATE_CHAIN_ID, ORDER_PICK_UP_DATE_FROM
              }
            />
          </div>
        : null}

        {driverOrdersPairs && driverOrdersPairs.length === 0 ?
        <div className={classes.justifyCenter}>
          {driverOrdersPairs && driverOrdersPairs.length === 0 && <span style={{ color: '#4c4c4c' }}>No matched orders</span>}
        </div> : null}
        
        {jels.jelData[DRIVER_TABLE_ID] && jels.jelData[ORDER_TABLE_ID] && driverOrdersPairs
          && driverOrdersPairs.map(([driverPid, matchedOrdersOids], index) => (
          <Paper key={index} elevation={0} className={classes.paperContainer}>
            <div className={classes.tableContainer}>
              <TrplsTable
                isEmbed
                smallHeadingBtns={true}
                preloadedData={
                  {
                    ...data,
                    total_query: 1,
                    query: [driverPid],
                  }
                }
                updateFilter={{
                  nodes: [driverPid],
                }}
                tableGroupIndex={driverPid + '-driver'}
                settings={jels.jelData[DRIVER_TABLE_ID]}
              />
            </div>

            <div className={`${classes.tableContainer} ${classes.mt20}`}>

              <TrplsTable
                isEmbed
                smallHeadingBtns={true}
                preloadedData={
                  {
                    ...data,
                    total_query: matchedOrdersOids.length,
                    query: matchedOrdersOids,
                  }
                }
                updateFilter={{trpls: [{pids_chain: [MATCHED_ORDER_PREDICATE_ID], val: driverPid}
                                        ,{pids_chain: [VALID_MATCHING_PREDICATE_ID], val: true}]}}
                tableGroupIndex={driverPid + '-orders'}
                settings={jels.jelData[ORDER_TABLE_ID]}
              />
            </div>
          </Paper>
        ))}
      </div>
    )
  }
}

export default connect((state) => (
  {
    jels: state.jels,
    setup: state.meta.setup,
  }
), { getJelData })(withStyles(styles)(MatchingPage));
